import { NotificationTypesEnum } from '@/_types/notifications';

export const NOTIFICATIONS_DATA: Record<
  NotificationTypesEnum,
  {
    name: string;
    description: string;
    isEnabled: boolean;
    category: string;
  }
> = {
  // Broad category types (used when no specific granular type applies)
  [NotificationTypesEnum.document_related]: {
    name: 'Document Related',
    description:
      'Notifications about document uploads, reviews, and status changes',
    isEnabled: true,
    category: 'Document',
  },
  [NotificationTypesEnum.questionnaire_related]: {
    name: 'Questionnaire Related',
    description:
      'Notifications about questionnaire submissions, updates, and completions',
    isEnabled: true,
    category: 'Questionnaire',
  },
  [NotificationTypesEnum.detail_change]: {
    name: 'Detail Change',
    description: 'Notifications about client profile and entity detail changes',
    isEnabled: true,
    category: 'Detail Change',
  },
  [NotificationTypesEnum.conversation_related]: {
    name: 'Conversation Related',
    description: 'Notifications about new messages and conversation updates',
    isEnabled: false,
    category: 'Conversation',
  },
  [NotificationTypesEnum.questionnaire_document_related]: {
    name: 'Questionnaire Document Related',
    description: 'Notifications about documents uploaded via questionnaires',
    isEnabled: true,
    category: 'Questionnaire',
  },
  [NotificationTypesEnum.drop_link_related]: {
    name: 'Drop Link Related',
    description: 'Notifications about drop link uploads',
    isEnabled: false,
    category: 'Document',
  },

  // Questionnaire notifications
  [NotificationTypesEnum.questionnaire_track_changes]: {
    name: 'Questionnaire Track Changes',
    description: 'When a client answers questions during preparation',
    isEnabled: true,
    category: 'Questionnaire',
  },
  [NotificationTypesEnum.questionnaire_submitted]: {
    name: 'Questionnaire Submitted',
    description: 'When a client submits a questionnaire for review',
    isEnabled: true,
    category: 'Questionnaire',
  },
  [NotificationTypesEnum.questionnaire_note_added]: {
    name: 'Note Added',
    description: 'When someone adds a comment or note to a questionnaire',
    isEnabled: true,
    category: 'Questionnaire',
  },
  [NotificationTypesEnum.questionnaire_signature_signed]: {
    name: 'Questionnaire Signature Signed',
    description:
      'When an engagement letter or agreement signature is completed',
    isEnabled: true,
    category: 'Signature',
  },

  // Document notifications
  [NotificationTypesEnum.document_uploaded_outside_questionnaire]: {
    name: 'Document Uploaded Outside Questionnaire',
    description: 'When documents are uploaded outside of any questionnaire',
    isEnabled: true,
    category: 'Document',
  },
  [NotificationTypesEnum.document_deleted]: {
    name: 'Document Deleted',
    description: 'When a document is deleted',
    isEnabled: true,
    category: 'Document',
  },
  [NotificationTypesEnum.document_moved]: {
    name: 'Document Moved',
    description: 'When a document is moved to a different location',
    isEnabled: true,
    category: 'Document',
  },

  // Tax Return notifications
  [NotificationTypesEnum.tax_return_signed]: {
    name: 'Tax Return Signed',
    description: 'When all signatures on a tax return are completed',
    isEnabled: true,
    category: 'Tax Return',
  },
  [NotificationTypesEnum.tax_return_paid]: {
    name: 'Tax Return Paid',
    description: 'When a client makes a payment for their tax return',
    isEnabled: true,
    category: 'Tax Return',
  },
  [NotificationTypesEnum.tax_return_draft_status_change]: {
    name: 'Tax Return Draft Status Change',
    description: 'When a tax return draft is approved or rejected',
    isEnabled: true,
    category: 'Tax Return',
  },

  // Info Change notifications
  [NotificationTypesEnum.client_info_updated]: {
    name: 'Client Info Updated',
    description: 'When client profile or contact information is changed',
    isEnabled: true,
    category: 'Detail Change',
  },
  [NotificationTypesEnum.entity_info_updated]: {
    name: 'Entity Info Updated',
    description: 'When company or entity details are changed',
    isEnabled: true,
    category: 'Detail Change',
  },

  // Assignment notifications
  [NotificationTypesEnum.firm_role_assigned]: {
    name: 'Firm Role Assigned',
    description: 'When someone assigns a firm role to you',
    isEnabled: true,
    category: 'Detail Change',
  },
  [NotificationTypesEnum.client_assigned]: {
    name: 'Client Assigned',
    description: 'When a client is assigned to you as assigned firm user',
    isEnabled: true,
    category: 'Detail Change',
  },

  // Signature Request notifications
  [NotificationTypesEnum.signature_request_signed]: {
    name: 'Signature Request Signed',
    description: 'When a client completes an e-signature request',
    isEnabled: true,
    category: 'Signature',
  },
};

export const BROAD_NOTIFICATION_TYPES = [
  NotificationTypesEnum.document_related,
  NotificationTypesEnum.questionnaire_related,
  NotificationTypesEnum.detail_change,
  NotificationTypesEnum.conversation_related,
];

export const BROAD_NOTIFICATION_TYPES_SET = new Set(BROAD_NOTIFICATION_TYPES);

export const CATEGORY_ORDER = [
  'Questionnaire',
  'Document',
  'Tax Return',
  'Signature',
  'Detail Change',
  'Conversation',
];
